import React from 'react';
import { useDispatch } from 'react-redux';
import logo from '../../assets/logo.png';
import { logout } from '../../features/auth/auth.slice';

const SideMenu = ({ menu, selectedPage, setSelectedPage }) => {
  const dispatch = useDispatch();

  return (
    <div className="px-5 flex flex-col items-center">
      <div className="flex flex-col items-center py-5 space-y-6">
        <img src={logo} alt="Postager Logo" />
        <button
          className="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-[80%] px-5 py-1 text-center"
          onClick={() =>
            setSelectedPage({
              title: 'AddPost',
            })
          }
        >
          ADD POST
        </button>
      </div>
      <div className="flex flex-col py-6">
        {menu.map((menu) => (
          <a
            href="#"
            className={`flex items-center space-x-5 hover:bg-neutral-300 transition-all duration-150 p-2 rounded-lg ${
              selectedPage.title === menu.title ? 'bg-neutral-300' : ''
            }`}
            onClick={() => setSelectedPage(menu)}
          >
            <i className={`fa-solid ${menu.icon}`}></i>
            <p>{menu.title}</p>
          </a>
        ))}
        <button
          className="text-white bg-darkblue hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-md text-sm w-[80%] px-5 py-1 text-center self-center mt-5"
          onClick={() => dispatch(logout())}
        >
          Logout
        </button>
      </div>
    </div>
  );
};

export default SideMenu;
